import { render, staticRenderFns } from "./historical-arbitrage-transaction-inquiry.vue?vue&type=template&id=41782328&scoped=true&"
import script from "./historical-arbitrage-transaction-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-arbitrage-transaction-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-arbitrage-transaction-inquiry.vue?vue&type=style&index=0&id=41782328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41782328",
  null
  
)

export default component.exports